export interface ModalParams {
    id: string;
    className: string;
    animateShow: string;
    animateHide: string;
    backdropAnimateShow: string;
    backdropAnimateHide: string;
    onShow: ((modal: Modal) => void) | null;
    onAfterShow: ((modal: Modal) => void) | null;
    onHide: ((modal: Modal) => void) | null,
    onAfterHide: ((modal: Modal) => void) | null,
    showCloseIcon: boolean;
}

class Modal {

    public container;
    public backdrop;
    public isOpen = false;
    protected options;
    protected defaults: ModalParams = {
        id: 'modal',
        className: '',
        animateShow: 'backInDown',
        animateHide: 'backOutUp',
        backdropAnimateShow: 'fadeIn',
        backdropAnimateHide: 'fadeOut',
        onShow: null,
        onAfterShow: null,
        onHide: null,
        onAfterHide: null,
        showCloseIcon: true,
    };

    constructor(params: Partial<ModalParams>, content?: any) {
        this.options = $.extend({}, this.defaults, params);
        content = typeof content !== 'undefined' ? content : '';

        this.build(content);
        this.container = $('#' + this.options.id);
        this.backdrop = $('#backdrop-' + this.options.id);


        this.container.on({
            'show.bs.modal': () => {
                if (this.options.onShow)
                    this.options.onShow(this);
            },
            'shown.bs.modal': () => {
                if (this.options.onAfterShow)
                    this.options.onAfterShow(this);
            },
            'hide.bs.modal': () => {
                if (this.options.onHide)
                    this.options.onHide(this);
            },
            'hidden.bs.modal': () => {
                if (this.options.onAfterHide)
                    this.options.onAfterHide(this);
            }
        });


        $('.modal-open').on('keydown', (e) => {
            if (e.which == 27) { // esc
                this.hide();
            }
        });

        if (this.options.showCloseIcon) {
            $('.modal-close').click(() => {
                console.log('1e')
                this.hide();
            });
        }

        this.backdrop.on('click', () => {
            this.hide();
        });
    }

    build(content) {
        let backdrop = $('<div class="modal-container-backdrop">');
        let html = $('<div class="modal-container container">').html(content);

        if (this.options.showCloseIcon) {
            html.append($('<span class="modal-close">')
                .append($('<svg><use xlink:href="#i-times"></use></svg>'))
            )
        }

        $('body')
            .append(
                $('<div>', {
                    id: this.options.id,
                    'class': 'modal main-modal animated ' + this.options.animateShow + ' ' + this.options.className
                })
                    .append($('<div class="modal-dialog-wrapper">')
                        .append(html)).append(backdrop)
            )
            .append($('<div>', {
                    id: 'backdrop-' + this.options.id,
                    'class': 'popup-backdrop animated ' + this.options.backdropAnimateShow + ' ' + this.options.className
                })
            );
    }

    setContent(content: any): void {
        this.container.find('.modal-container').html(content);
    }

    show(): void {
        this.container.modal({
            show: true,
            backdrop: false
        });
        this.backdrop.addClass('show');
        this.isOpen = true;
    }

    hide(): void {
        this.container.removeClass(this.options.animateShow).addClass(this.options.animateHide);
        this.backdrop.removeClass(this.options.backdropAnimateShow).addClass(this.options.backdropAnimateHide);
        // ожидаем окончания анимации todo запилить анимацию на js
        setTimeout(() => {
            this.container.modal('hide');
            this.backdrop.removeClass('show');
            this.container.addClass(this.options.animateShow).removeClass(this.options.animateHide);
            this.backdrop.addClass(this.options.backdropAnimateShow).removeClass(this.options.backdropAnimateHide);
        }, 1000);
        this.isOpen = false;
    }

    destroy(): void {
        $('.modal-open').off('keydown');
        if (this.options.showCloseIcon) {
            $('.modal-close').off('click');
        }
        this.backdrop.off('keydown');

        this.container.modal('dispose');
        this.container.remove();
        this.backdrop.remove();
    }
}

export default Modal;
